import { render } from "./EventCard.vue?vue&type=template&id=bf73e09e&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=bf73e09e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bf73e09e"

export default script